import React from 'react';
import Setting from 'containers/Setting';

const SettingIndex = props => <Setting {...props} />;

SettingIndex.propTypes = {};

export default SettingIndex;
